<template>
  <tr class="group/tr" @click="onClick">
    <slot />
  </tr>
</template>
<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'click'): void;
}>();
const onClick = () => emit('click');
</script>
